import { api } from './api';

const companyInfoGetList = async () => {
  const response = await api({
    url: `CompanyInfos/getList`,
    method: 'GET',
  });
  return response.data;
};

const updateCompanyInfos = async (data) => {
  const response = await api({
    url: `CompanyInfos/update`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const addCompanyInfoFiles = async (data) => {
  const response = await api({
    url: `CompanyInfoFiles/add`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return response.data;
};

const companyInfosServices = {
  companyInfoGetList,
  updateCompanyInfos,
  addCompanyInfoFiles,
};

export default companyInfosServices;
